module.exports = __webpack_public_path__ + "e7a7c03757e3507dd5915c2403ca9697.svg";